function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  rx: 30,
  fill: "#FD7E50"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6774 18.5161C19.6774 17.3759 20.6017 16.4516 21.7419 16.4516H27.2903C28.4305 16.4516 29.3548 17.3759 29.3548 18.5161V27.2903C29.3548 28.4305 28.4305 29.3548 27.2903 29.3548H21.7419C20.6017 29.3548 19.6774 28.4305 19.6774 27.2903V18.5161Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M41.4839 19.6774C42.6241 19.6774 43.5484 20.6017 43.5484 21.7419V27.2903C43.5484 28.4305 42.6241 29.3548 41.4839 29.3548H32.7097C31.5695 29.3548 30.6452 28.4305 30.6452 27.2903V21.7419C30.6452 20.6017 31.5695 19.6774 32.7097 19.6774L41.4839 19.6774Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2903 30.6452C28.4305 30.6452 29.3548 31.5695 29.3548 32.7097V38.2581C29.3548 39.3983 28.4305 40.3226 27.2903 40.3226H18.5161C17.3759 40.3226 16.4516 39.3983 16.4516 38.2581V32.7097C16.4516 31.5695 17.3759 30.6452 18.5161 30.6452H27.2903Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M40.3226 41.4839C40.3226 42.6241 39.3983 43.5484 38.2581 43.5484H32.7097C31.5695 43.5484 30.6452 42.6241 30.6452 41.4839L30.6452 32.7097C30.6452 31.5695 31.5695 30.6452 32.7097 30.6452H38.2581C39.3983 30.6452 40.3226 31.5695 40.3226 32.7097L40.3226 41.4839Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M50 24.5806C50 26.0059 48.8446 27.1613 47.4194 27.1613C45.9941 27.1613 44.8387 26.0059 44.8387 24.5806C44.8387 23.1554 45.9941 22 47.4194 22C48.8446 22 50 23.1554 50 24.5806Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1613 12.5806C27.1613 14.0059 26.0059 15.1613 24.5806 15.1613C23.1554 15.1613 22 14.0059 22 12.5806C22 11.1554 23.1554 10 24.5806 10C26.0059 10 27.1613 11.1554 27.1613 12.5806Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M38.129 47.4194C38.129 48.8446 36.9736 50 35.5484 50C34.1231 50 32.9677 48.8446 32.9677 47.4194C32.9677 45.9941 34.1231 44.8387 35.5484 44.8387C36.9736 44.8387 38.129 45.9941 38.129 47.4194Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1613 35.5484C15.1613 36.9736 14.0059 38.129 12.5806 38.129C11.1554 38.129 10 36.9736 10 35.5484C10 34.1231 11.1554 32.9677 12.5806 32.9677C14.0059 32.9677 15.1613 34.1231 15.1613 35.5484Z",
  fill: "white"
});

function SvgLogoAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAvatar);
export default __webpack_public_path__ + "static/media/logoAvatar.c4d467d2.svg";
export { ForwardRef as ReactComponent };